import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

export function OfflineBanner() {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border-b border-yellow-200 text-yellow-800">
      <div className="container mx-auto px-4 py-2 text-sm flex items-center gap-2">
        <WifiOff className="w-4 h-4" />
        <p>オフラインです。接続が復帰すると自動で同期されます。</p>
      </div>
    </div>
  );
}
